<!-- eslint-disable max-len -->
<template>
  <div>
    <h2>LMS Configuration Values</h2>
    <text-input :disabled="true" label v-model="classToEdit.ltiConsumerKey" copyable no-count>
      Consumer Key
    </text-input>

    <text-input :disabled="true" label v-model="classToEdit.ltiSharedSecret" copyable no-count>
      Shared Secret
    </text-input>

    <text-input :disabled="true" label v-model="configUrl" copyable no-count>
      Config URL
    </text-input>

    <hr />
    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.setup-guide variant="info" class="lti-accordion-button">
            Canvas Setup Guide
          </b-button>
        </b-card-header>
        <b-collapse id="setup-guide" accordion="setup-accordion" role="tabpanel">
          <h2>Canvas Setup Guide</h2>
          <p>
            Open the dashboard for the course that you wish to set up for this class.  Click on the
            <span class="click-action">Settings</span> button in the navigation panel.
            <img class="guide-img" src="../../../../assets/lti-setup-guide/01-dashboard.png"/>
          </p>
          <hr />
          <p>
            Click on the  <span class="click-action">Apps</span> tab.
            <img class="guide-img" src="../../../../assets/lti-setup-guide/02-settings.png"/>
          </p>
          <hr />
          <p>
            Click on the  <span class="click-action">View App Configurations</span> button.
            <img class="guide-img" src="../../../../assets/lti-setup-guide/03-apps.png"/>
          </p>
          <hr />
          <p>
            Click on the  <span class="click-action">+ App</span> button.
            <img
              class="guide-img"
              src="../../../../assets/lti-setup-guide/04-app-configurations.png"
            />
          </p>
          <hr />
          <p>
            Click on the <span class="click-action">Configuration Type</span> dropdown and select
            <span class="click-action">By URL</span>.
            <img class="guide-img" src="../../../../assets/lti-setup-guide/05-add-app-manual.png"/>
            <img class="guide-img" src="../../../../assets/lti-setup-guide/05-2-select-by-url.png"/>
          </p>
          <hr />
          <p>
            Fill in the fields with the highlighted fields with the values provided above.
            (also provided below for convenience).  The <span class="click-action">Name</span>
            field can be anything, but it should probably be the name of the gamulation.  If
            you want to set Blade up to be used for assignments, then this is the name you
            will select during that process.

            <br/>

            <i><b>Ensure that you check the <span class="click-action">Allow this tool
            to access the IMS Names and Roles Provisioning Service</span> checkbox.</b></i>
            <img class="guide-img" src="../../../../assets/lti-setup-guide/06-add-app-by-url.png"/>

            <text-input :disabled="true" label v-model="classToEdit.ltiConsumerKey" copyable no-count>
              Consumer Key
            </text-input>

            <text-input :disabled="true" label v-model="classToEdit.ltiSharedSecret" copyable no-count>
              Shared Secret
            </text-input>

            <text-input :disabled="true" label v-model="configUrl" copyable no-count>
              Config URL
            </text-input>
          </p>

          <p>
            Finally, click the <b>Submit</b> button.
          </p>
        </b-collapse>
      </b-card>
      <b-card no-body class="mb-1" v-if="classToEdit.canvasAssignmentSectionPlacement">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.assignment-guide variant="info" class="lti-accordion-button">
            Canvas Assignment Setup Guide
          </b-button>
        </b-card-header>
        <b-collapse id="assignment-guide" accordion="setup-accordion" role="tabpanel">
          <h2>Canvas Assignment Setup Guide</h2>
          <p>
            On the assignment that you would like to set up, change the <b>Submission Type</b> from
            <span class="click-action">Online</span> to
            <span class="click-action">External Tool</span>.
            <img
              class="guide-img"
              src="../../../../assets/lti-assignment-guide/01-submission-type.png"
            />
            <img
              class="guide-img"
              src="../../../../assets/lti-assignment-guide/02-external-tool.png"
            />
          </p>
          <hr />
          <p>
            Click the <span class="click-action">Find</span> button.
            <img
              class="guide-img"
              src="../../../../assets/lti-assignment-guide/03-exernal-tool-find-btn.png"
            />
          </p>
          <hr />
          <p>
            <span class="click-action">Select</span> the external tool that
            you configured during <b>Canvas Setup Guide</b>.
            <img
              class="guide-img"
              src="../../../../assets/lti-assignment-guide/04-configure-external-tool-select-blade.png"
            />
          </p>
          <hr />
          <p>
            Finally, set the <span class="click-action">Points</span> field to the number of Sections in the Gamulation.
            <img
              class="guide-img"
              src="../../../../assets/lti-assignment-guide/05-points-box.png"
            />

            For example, if there are 4 Sections in the Gamulation (as is the case for ALG), set the <span class="click-action">Points</span> field to <span class="click-action">4</span>.

            <img
              class="guide-img"
              src="../../../../assets/lti-assignment-guide/06-points-box-4-points.png"
            />
          </p>
        </b-collapse>
      </b-card>
    </div>
  </div>
</template>

<script>
import { axiosAPIInstance as axios } from '../../../../axios-config';
import TextInput from '../../../ui/inputs/TextInput';

export default {
  components: { TextInput },
  props: {
    classToEdit: Object
  },
  computed: {
    configUrl() {
      return `${axios.defaults.baseURL}blade/classes/${this.classToEdit._id}/lti/config.xml`;
    }
  },
  data() {
    return {
      showSetup: false
    };
  }
};
</script>

<style lang="scss" scoped>
.fieldPrependString {
  width: 120px;
}

.fieldAppendButton {
  width: 80px;
}

.click-action {
  font-weight: bold;
  color: red;
}

.guide-img {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
}
.lti-accordion-button {
  border-radius: 0px;
  width: 100%;
  font-size: 20px;
   height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/blade/pages/components/ClassLtiInfoModal.vue